//Dimentions for the different cases
const MAX_IMG_TEXT_PX_DIM = 1280;
const MAX_IMG_PAGE_PX_DIM_WIDTH = 2480;
const MAX_IMG_PAGE_PX_DIM_HIEGHT = 3508;
const MAX_IMG_POS_PX_DIM = 720;
//What is the compression quality?
const IMG_QUALITY_PRE_TEXT = 85;
const IMG_QUALITY_PAGE = 70;
const IMG_QUALITY_POS = 70;
//The max size we allow to upload. This restriction is set on the backend.
export const MAX_FILE_SIZE_BYTE = 512000;
const IMG_COMPRESS_FORMAT = "jpeg";
class Resizer {
    static changeHeightWidth(height, maxHeight, width, maxWidth, minWidth, minHeight) {
        if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
        }
        if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height);
            height = maxHeight;
        }
        if (minWidth && width < minWidth) {
            height = Math.round((height * minWidth) / width);
            width = minWidth;
        }
        if (minHeight && height < minHeight) {
            width = Math.round((width * minHeight) / height);
            height = minHeight;
        }
        return { height, width };
    }
    static resizeAndRotateImage(image, maxWidth, maxHeight, compressFormat = IMG_COMPRESS_FORMAT, quality, rotation = 0) {
        var qualityDecimal = quality / 100;
        var canvas = document.createElement("canvas");
        var width = image.width;
        var height = image.height;
        var newHeightWidth = this.changeHeightWidth(height, maxHeight, width, maxWidth, 0, 0);
        canvas.width = newHeightWidth.width;
        canvas.height = newHeightWidth.height;
        width = newHeightWidth.width;
        height = newHeightWidth.height;
        var ctx = canvas.getContext("2d");
        if (ctx == null) {
            console.error("No canvas for image resize");
            return "";
        }
        ctx.fillStyle = "rgba(0, 0, 0, 0)";
        ctx.fillRect(0, 0, width, height);
        if (ctx.imageSmoothingEnabled && ctx.imageSmoothingQuality) {
            ctx.imageSmoothingQuality = 'high';
        }
        if (rotation) {
            ctx.rotate((rotation * Math.PI) / 180);
            if (rotation === 90) {
                ctx.translate(0, -canvas.width);
            }
            else if (rotation === 180) {
                ctx.translate(-canvas.width, -canvas.height);
            }
            else if (rotation === 270) {
                ctx.translate(-canvas.height, 0);
            }
            else if (rotation === 0 || rotation === 360) {
                ctx.translate(0, 0);
            }
        }
        ctx.drawImage(image, 0, 0, width, height);
        return canvas.toDataURL(`image/${compressFormat}`, qualityDecimal);
    }
    static b64toByteArrays(b64Data, contentType) {
        contentType = contentType || "image/jpeg";
        var sliceSize = 512;
        var byteCharacters = atob(b64Data.toString().replace(/^data:image\/(png|jpeg|jpg|webp);base64,/, ""));
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return byteArrays;
    }
    static b64toFile(b64Data, fileName, contentType) {
        const byteArrays = this.b64toByteArrays(b64Data, contentType);
        const file = new File(byteArrays, fileName, { type: contentType });
        return file;
    }
    static createResizedImage(file, responseUriFunc, maxResWidth, maxResHight, quality) {
        const reader = new FileReader();
        if (file) {
            if (file.type && !file.type.includes("image")) {
                throw Error("File Is NOT Image!");
            }
            else {
                reader.readAsDataURL(file);
                reader.onload = () => {
                    var image = new Image();
                    image.src = reader.result;
                    image.onload = function () {
                        var resizedDataUrl = Resizer.resizeAndRotateImage(image, maxResWidth, maxResHight, IMG_COMPRESS_FORMAT, quality, 0);
                        const contentType = `image/${IMG_COMPRESS_FORMAT}`;
                        let fileName = file.name;
                        let fileNameWithoutFormat = fileName.toString().replace(/(png|jpeg|jpg|webp)$/i, "");
                        let newFileName = fileNameWithoutFormat.concat(IMG_COMPRESS_FORMAT.toString());
                        const newFile = Resizer.b64toFile(resizedDataUrl, newFileName, contentType);
                        responseUriFunc(newFile);
                    };
                };
                reader.onerror = (error) => {
                    throw error;
                };
            }
        }
        else {
            throw Error("File Not Found!");
        }
    }
}
export function imageFileResizer(file, useCase, responseUriFunc) {
    //Default is POS resolutions
    let maxWidth = MAX_IMG_POS_PX_DIM;
    let maxHeight = MAX_IMG_POS_PX_DIM;
    let quality = IMG_QUALITY_POS;
    switch (useCase) {
        case "PRE_TEXT":
            maxWidth = MAX_IMG_TEXT_PX_DIM;
            maxHeight = MAX_IMG_TEXT_PX_DIM;
            quality = IMG_QUALITY_PRE_TEXT;
            break;
        case "PAGE":
            maxWidth = MAX_IMG_PAGE_PX_DIM_WIDTH;
            maxHeight = MAX_IMG_PAGE_PX_DIM_HIEGHT;
            quality = IMG_QUALITY_PAGE;
            break;
    }
    //Create the resizer object.
    return Resizer.createResizedImage(file, responseUriFunc, maxWidth, maxHeight, quality);
}
;
